import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import logo from "../../../images/PPKM_Head.png";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EventIcon from "@mui/icons-material/Event";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PersonIcon from "@mui/icons-material/Person";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import GroupsIcon from "@mui/icons-material/Groups";
import EditNoteIcon from "@mui/icons-material/EditNote";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import FolderIcon from "@mui/icons-material/Folder";
import { useLocation } from "react-router-dom";
import "./header.css";
import LogoutIcon from "@mui/icons-material/Logout";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom"; // Import Link
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import FeedIcon from "@mui/icons-material/Feed";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import CellTowerIcon from "@mui/icons-material/CellTower";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import HistoryIcon from "@mui/icons-material/History";
import CollectionsIcon from "@mui/icons-material/Collections";
import UploadIcon from "@mui/icons-material/Upload";
import HelpIcon from "@mui/icons-material/Help";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import AppShortcutIcon from '@mui/icons-material/AppShortcut';
import SummarizeIcon from '@mui/icons-material/Summarize';

//added by delon - 2025-03-26
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import WallpaperIcon from '@mui/icons-material/Wallpaper';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import DraftsIcon from '@mui/icons-material/Drafts';

const Lists = [
  {
    title: "Reports",
    iconTitle: <SummarizeIcon />,
    href: "/ppkm/admin/dashboard",
    path: "/ppkm/admin/dashboard",
  },
];
const drawerWidth = 250;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
      },
    },
  ],
}));

export default function MiniDrawer({ children }) {
  const location = useLocation();
  const pathname = "/ppkm" + location.pathname;

  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  const [openCollapseMembership, setOpenCollapseMembership] =
    React.useState(false);
  const [openCollapseEvent, setOpenCollapseEvent] = React.useState(false);
  const [openCollapseResources, setOpenCollapseResources] =
    React.useState(false);
  const [openCollapsePhotoGallery, setOpenCollapsePhotoGallery] =
    React.useState(false);
  const [openCollapseBroadcast, setOpenCollapseBroadcast] =
    React.useState(false);
  const [openCollapseSignature, setOpenCollapseSignature] =
    React.useState(false);
  const [openCollapseInvoice, setOpenCollapseInvoice] = React.useState(false);
  const [openCollapseInvoiceNotes, setOpenCollapseInvoiceNotes] =
    React.useState(false);
  const [openCollapseApplicationForm, setOpenCollapseApplicationForm] =
    React.useState(false);
  const [openCollapseSecretariat, setOpenCollapseSecretariat] =
    React.useState(false);
  const [openCollapseAuditTrail, setOpenCollapseAuditTrail] =
    React.useState(false);
  const [openCollapseUserManual, setOpenCollapseUserManual] =
    React.useState(false);
  const [openCollapseEmailBlast, setOpenCollapseEmailBlast] =
    React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleClickMembership = () => {
    setOpenCollapseMembership(!openCollapseMembership);
  };

  const handleClickEvent = () => {
    setOpenCollapseEvent(!openCollapseEvent);
  };

  const handleClickDocument = () => {
    setOpenCollapseResources(!openCollapseResources);
  };

  const handleClickPhotoGallery = () => {
    setOpenCollapsePhotoGallery(!openCollapsePhotoGallery);
  };

  const handleClickBroadcast = () => {
    setOpenCollapseBroadcast(!openCollapseBroadcast);
  };

  const handleClickSignature = () => {
    setOpenCollapseSignature(!openCollapseSignature);
  };

  // const handleClickInvoice = () => {
  //   setOpenCollapseInvoice(!openCollapseInvoice);
  // };

  // const handleClickInvoiceNotes = () => {
  //   setOpenCollapseInvoiceNotes(!openCollapseInvoiceNotes);
  // };

  const handleClickApplicationForm = () => {
    setOpenCollapseApplicationForm(!openCollapseApplicationForm);
  };

  const handleClickSecretariat = () => {
    setOpenCollapseSecretariat(!openCollapseSecretariat);
  };

  const handleClickAuditTrail = () => {
    setOpenCollapseAuditTrail(!openCollapseAuditTrail);
  };

  const handleClickUserManual = () => {
    setOpenCollapseUserManual(!openCollapseUserManual);
  };

  const handleClickEmailBlast = () => {
    setOpenCollapseEmailBlast(!openCollapseEmailBlast);
  };

  React.useEffect(() => {
    // Define a mapping of pathnames to state setters
    const stateMapping = [
      {
        paths: [
          "/ppkm/admin/event",
          "/ppkm/admin/event_info",
          "/ppkm/admin/event_categories",
          "/ppkm/admin/create_event",
          "/ppkm/admin/create_event_categories",
        ],
        setter: setOpenCollapseEvent,
      },
      {
        paths: [
          "/ppkm/admin/resources",
          "/ppkm/admin/resources_categories",
          "/ppkm/admin/create_resources",
          "/ppkm/admin/create_resources_categories",
        ],
        setter: setOpenCollapseResources,
      },
      {
        paths: ["/ppkm/admin/photo_gallery", "/ppkm/admin/upload_gallery"],
        setter: setOpenCollapsePhotoGallery,
      },
      {
        paths: ["/ppkm/admin/broadcasts", "/ppkm/admin/create_broadcast"],
        setter: setOpenCollapseBroadcast,
      },
      {
        paths: [
          "/ppkm/admin/corporate_membership_applications",
          "/ppkm/admin/individual_membership_applications",
          "/ppkm/admin/affiliate_corporate_membership_applications",
          "/ppkm/admin/affiliate_individual_membership_applications",
          "/ppkm/admin/associate_membership_applications",
          "/ppkm/admin/honorary_membership_applications",
          "/ppkm/admin/corporate_info",
          "/ppkm/admin/member_user_info",
          "/ppkm/admin/add_corporate_member",
        ],
        setter: setOpenCollapseMembership,
      },
      {
        paths: ["/ppkm/admin/create_signature_info"],
        setter: setOpenCollapseSignature,
      },
      {
        paths: ["/ppkm/admin/membership_invoice", "/ppkm/admin/event_invoice"],
        setter: setOpenCollapseInvoice,
      },
      {
        paths: ["/ppkm/admin/corporate_form", "/ppkm/admin/individual_form"],
        setter: setOpenCollapseApplicationForm,
      },
      {
        paths: [
          "/ppkm/admin/cms_audits",
          "/ppkm/admin/mobile_audits",
          "/ppkm/admin/web_audits",
        ],
        setter: setOpenCollapseAuditTrail,
      },
      {
        paths: ["/ppkm/admin/event_blast", "/ppkm/admin/blast_history"],
        setter: setOpenCollapseEmailBlast,
      },
    ];

    // Iterate over the mapping and set the states dynamically
    stateMapping.forEach(({ paths, setter }) => {
      setter(paths.includes(pathname));
    });
  }, [pathname]);

  const navigate = useNavigate();
  const handleLogout = () => {
    const preservedValue = localStorage.getItem("userSignature");
    localStorage.clear(); // Clears everything
    localStorage.setItem("userSignature", preservedValue); // Restore the preserved value

    navigate("/admin/login"); // Redirect to login
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" className="admin-header" open={open}>
        <Toolbar>
          <Stack
            direction="row"
            spacing={2}
            sx={{ flexGrow: 1, alignItems: "center" }}
          >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={[
                {
                  marginRight: 5,
                },
                open && { display: "none" },
              ]}
            >
              <MenuIcon />
            </IconButton>
            <img src={logo} className="admin-logo" alt="logo" />

            <Typography variant="h6" noWrap component="div">
              PPKM ADMIN
            </Typography>
          </Stack>
          {/* Add a spacer to push the Logout icon to the right */}
          <Box sx={{ flexGrow: 1 }} />

          <Tooltip title="Logout">
            <IconButton color="inherit" onClick={handleLogout}>
              <LogoutIcon />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {Lists.map((item, index) => (
            <ListItem key={item.title} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={[
                  {
                    minHeight: 48,
                    px: 2.5,
                  },
                  open
                    ? {
                        justifyContent: "initial",
                      }
                    : {
                        justifyContent: "center",
                      },
                ]}
                // component={Link}
                to={item.href}
                selected={item.path === pathname}
              >
                <ListItemIcon
                  sx={[
                    {
                      minWidth: 0,
                      justifyContent: "center",
                    },
                    open
                      ? {
                          mr: 3,
                        }
                      : {
                          mr: "auto",
                        },
                  ]}
                >
                  {item.iconTitle}
                </ListItemIcon>
                <ListItemText
                  primary={item.title}
                  sx={[
                    open
                      ? {
                          opacity: 1,
                        }
                      : {
                          opacity: 0,
                        },
                  ]}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Divider />
        {/** added by delon on 2025-03-26 */}
        <button
          className="mall-gallery-btn"
          onClick={() => navigate("/admin/mall_gallery")}
        >
          <AccountBalanceIcon />
          Mall Gallery
        </button>
        <button className='mall-gallery-btn' onClick={() => navigate('/admin/admin_event_gallery')}>
          <WallpaperIcon />
          Event Gallery
        </button>
        <button className='mall-gallery-btn' onClick={() => navigate('/admin/admin_notice_board')}>
          <AssignmentLateIcon />
          Notice Board
        </button>

        <List>
          <ListItem key="event" disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={[
                {
                  minHeight: 48,
                  px: 2.5,
                },
                open
                  ? {
                      justifyContent: "initial",
                    }
                  : {
                      justifyContent: "center",
                    },
              ]}
              onClick={handleClickEvent}
            >
              <ListItemIcon
                sx={[
                  {
                    minWidth: 0,
                    justifyContent: "center",
                  },
                  open
                    ? {
                        mr: 3,
                      }
                    : {
                        mr: "auto",
                      },
                ]}
              >
                <EventIcon />
              </ListItemIcon>
              <ListItemText
                primary="Event"
                sx={[
                  open
                    ? {
                        opacity: 1,
                      }
                    : {
                        opacity: 0,
                      },
                ]}
              />
              {openCollapseEvent ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={openCollapseEvent} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/event"
                  selected={
                    pathname === "/ppkm/admin/event" ||
                    pathname.includes("/ppkm/admin/event_info") ||
                    pathname.includes("/ppkm/admin/event_blast")
                  }
                >
                  <ListItemIcon>
                    <EditCalendarIcon />
                  </ListItemIcon>
                  <ListItemText primary="Events" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/create_event"
                  selected={pathname === "/ppkm/admin/create_event"}
                >
                  <ListItemIcon>
                    <AddCircleOutlineIcon />
                  </ListItemIcon>
                  <ListItemText primary="Create Event" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/event_categories"
                  selected={pathname === "/ppkm/admin/event_categories"}
                >
                  <ListItemIcon>
                    <EditNoteIcon />
                  </ListItemIcon>
                  <ListItemText primary="Events Categories" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/create_event_categories"
                  selected={pathname === "/ppkm/admin/create_event_categories"}
                >
                  <ListItemIcon>
                    <AddCircleOutlineIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Create Event Categories"
                    sx={{
                      whiteSpace: "normal", // Allow text to wrap
                      overflow: "hidden", // Optional: hides overflowed text
                      textOverflow: "ellipsis", // Optional: adds ellipsis if text overflows
                    }}
                  />
                </ListItemButton>
              </List>
            </Collapse>
          </ListItem>
        </List>

        <List>
          <ListItem key="blast" disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={[
                {
                  minHeight: 48,
                  px: 2.5,
                },
                open
                  ? {
                      justifyContent: "initial",
                    }
                  : {
                      justifyContent: "center",
                    },
              ]}
              onClick={handleClickEmailBlast}
            >
              <ListItemIcon
                sx={[
                  {
                    minWidth: 0,
                    justifyContent: "center",
                  },
                  open
                    ? {
                        mr: 3,
                      }
                    : {
                        mr: "auto",
                      },
                ]}
              >
                <AttachEmailIcon />
              </ListItemIcon>
              <ListItemText
                primary="Email Blast"
                sx={[
                  open
                    ? {
                        opacity: 1,
                      }
                    : {
                        opacity: 0,
                      },
                ]}
              />
              {openCollapseEmailBlast ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={openCollapseEmailBlast} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {/* Email Blast */}
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/event_blast"
                  selected={pathname === "/ppkm/admin/event_blast"}
                >
                  <ListItemIcon>
                    <AttachEmailIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Blast"
                    sx={{
                      whiteSpace: "normal", // Allow text to wrap
                      overflow: "hidden", // Optional: hides overflowed text
                      textOverflow: "ellipsis", // Optional: adds ellipsis if text overflows
                    }}
                  />
                </ListItemButton>
                {/* Email Draft */}
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/blast_draft"
                  selected={pathname === "/ppkm/admin/blast_draft"}
                >
                  <ListItemIcon>
                    <DraftsIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Blast Drafts"
                    sx={{
                      whiteSpace: "normal", // Allow text to wrap
                      overflow: "hidden", // Optional: hides overflowed text
                      textOverflow: "ellipsis", // Optional: adds ellipsis if text overflows
                    }}
                  />
                </ListItemButton>
                {/* Email History */}
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/blast_history"
                  selected={pathname === "/ppkm/admin/blast_history"}
                >
                  <ListItemIcon>
                    <HistoryIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Blasts History"
                    sx={{
                      whiteSpace: "normal", // Allow text to wrap
                      overflow: "hidden", // Optional: hides overflowed text
                      textOverflow: "ellipsis", // Optional: adds ellipsis if text overflows
                    }}
                  />
                </ListItemButton>
              </List>
            </Collapse>
          </ListItem>
        </List>

        <List>
          <ListItem key="document" disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={[
                {
                  minHeight: 48,
                  px: 2.5,
                },
                open
                  ? {
                      justifyContent: "initial",
                    }
                  : {
                      justifyContent: "center",
                    },
              ]}
              onClick={handleClickDocument}
            >
              <ListItemIcon
                sx={[
                  {
                    minWidth: 0,
                    justifyContent: "center",
                  },
                  open
                    ? {
                        mr: 3,
                      }
                    : {
                        mr: "auto",
                      },
                ]}
              >
                <FolderIcon />
              </ListItemIcon>
              <ListItemText
                primary="Resources"
                sx={[
                  open
                    ? {
                        opacity: 1,
                      }
                    : {
                        opacity: 0,
                      },
                ]}
              />
              {openCollapseResources ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={openCollapseResources} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {/* Document List */}
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/resources"
                  selected={pathname === "/ppkm/admin/resources"}
                >
                  <ListItemIcon>
                    <FolderCopyIcon />
                  </ListItemIcon>
                  <ListItemText primary="Resources" />
                </ListItemButton>
                {/* Create Resources */}
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/create_resources"
                  selected={pathname === "/ppkm/admin/create_resources"}
                >
                  <ListItemIcon>
                    <AddCircleOutlineIcon />
                  </ListItemIcon>
                  <ListItemText primary="Create Resources" />
                </ListItemButton>
                {/* Document Categories List */}
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/resources_categories"
                  selected={pathname === "/ppkm/admin/resources_categories"}
                >
                  <ListItemIcon>
                    <EditNoteIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Resources Categories"
                    sx={{
                      whiteSpace: "normal", // Allow text to wrap
                      overflow: "hidden", // Optional: hides overflowed text
                      textOverflow: "ellipsis", // Optional: adds ellipsis if text overflows
                    }}
                  />
                </ListItemButton>
                {/* Create Resources Categories */}
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/create_resources_categories"
                  selected={
                    pathname === "/ppkm/admin/create_resources_categories"
                  }
                >
                  <ListItemIcon>
                    <AddCircleOutlineIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Create Resources Categories"
                    sx={{
                      whiteSpace: "normal", // Allow text to wrap
                      overflow: "hidden", // Optional: hides overflowed text
                      textOverflow: "ellipsis", // Optional: adds ellipsis if text overflows
                    }}
                  />
                </ListItemButton>
              </List>
            </Collapse>
          </ListItem>
        </List>

        {/* Photo gallery */}
        {/* <List>
          <ListItem
            key="photo_gallery"
            disablePadding
            sx={{ display: "block" }}
          >
            <ListItemButton
              sx={[
                {
                  minHeight: 48,
                  px: 2.5,
                },
                open
                  ? {
                      justifyContent: "initial",
                    }
                  : {
                      justifyContent: "center",
                    },
              ]}
              onClick={handleClickPhotoGallery}
            >
              <ListItemIcon
                sx={[
                  {
                    minWidth: 0,
                    justifyContent: "center",
                  },
                  open
                    ? {
                        mr: 3,
                      }
                    : {
                        mr: "auto",
                      },
                ]}
              >
                <CollectionsIcon />
              </ListItemIcon>
              <ListItemText
                primary="Photo Gallery"
                sx={[
                  open
                    ? {
                        opacity: 1,
                      }
                    : {
                        opacity: 0,
                      },
                ]}
              />
              {openCollapsePhotoGallery ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse
              in={openCollapsePhotoGallery}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/photo_gallery"
                  selected={pathname === "/ppkm/admin/photo_gallery"}
                >
                  <ListItemIcon>
                    <CollectionsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Photo Gallery" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/upload_photo"
                  selected={pathname === "/ppkm/admin/upload_photo"}
                >
                  <ListItemIcon>
                    <UploadIcon />
                  </ListItemIcon>
                  <ListItemText primary="Upload" />
                </ListItemButton>
              </List>
            </Collapse>
          </ListItem>
        </List> */}

        <List>
          <ListItem key="broadcast" disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={[
                {
                  minHeight: 48,
                  px: 2.5,
                },
                open
                  ? {
                      justifyContent: "initial",
                    }
                  : {
                      justifyContent: "center",
                    },
              ]}
              onClick={handleClickBroadcast}
            >
              <ListItemIcon
                sx={[
                  {
                    minWidth: 0,
                    justifyContent: "center",
                  },
                  open
                    ? {
                        mr: 3,
                      }
                    : {
                        mr: "auto",
                      },
                ]}
              >
                <CellTowerIcon />
              </ListItemIcon>
              <ListItemText
                primary="Broadcast"
                sx={[
                  open
                    ? {
                        opacity: 1,
                      }
                    : {
                        opacity: 0,
                      },
                ]}
              />
              {openCollapseBroadcast ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={openCollapseBroadcast} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {/* Broadcast List */}
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/broadcasts"
                  selected={pathname === "/ppkm/admin/broadcasts"}
                >
                  <ListItemIcon>
                    <CellTowerIcon />
                  </ListItemIcon>
                  <ListItemText primary="Broadcasts" />
                </ListItemButton>
                {/* Create Broadcast */}
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/create_broadcast"
                  selected={pathname === "/ppkm/admin/create_broadcast"}
                >
                  <ListItemIcon>
                    <AddCircleOutlineIcon />
                  </ListItemIcon>
                  <ListItemText primary="Create Broadcast" />
                </ListItemButton>
              </List>
            </Collapse>
          </ListItem>
        </List>

        <List>
          <ListItem key="membership" disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={[
                {
                  minHeight: 48,
                  px: 2.5,
                },
                open
                  ? {
                      justifyContent: "initial",
                    }
                  : {
                      justifyContent: "center",
                    },
              ]}
              onClick={handleClickMembership}
            >
              <ListItemIcon
                sx={[
                  {
                    minWidth: 0,
                    justifyContent: "center",
                  },
                  open
                    ? {
                        mr: 3,
                      }
                    : {
                        mr: "auto",
                      },
                ]}
              >
                <PersonAddIcon />
              </ListItemIcon>
              <ListItemText
                primary="Membership"
                sx={[
                  open
                    ? {
                        opacity: 1,
                      }
                    : {
                        opacity: 0,
                      },
                ]}
              />
              {openCollapseMembership ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openCollapseMembership} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link} // Use Link here
                  href="/ppkm/admin/corporate_membership_applications" // Use to instead of href
                  selected={
                    pathname ===
                      "/ppkm/admin/corporate_membership_applications" ||
                    pathname.includes("/ppkm/admin/corporate_info") ||
                    pathname.includes("/ppkm/admin/member_user_info") ||
                    pathname.includes("/ppkm/admin/add_corporate_member")
                  }
                >
                  <ListItemIcon>
                    <GroupsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Corporate" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link} // Use Link here
                  href="/ppkm/admin/individual_membership_applications" // Use to instead of href
                  selected={
                    pathname ===
                    "/ppkm/admin/individual_membership_applications"
                  }
                >
                  <ListItemIcon>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText primary="Individual" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link} // Use Link here
                  href="/ppkm/admin/affiliate_corporate_membership_applications" // Use to instead of href
                  selected={
                    pathname ===
                    "/ppkm/admin/affiliate_corporate_membership_applications"
                  }
                >
                  <ListItemIcon>
                    <GroupsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Affiliate Corporate" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link} // Use Link here
                  href="/ppkm/admin/affiliate_individual_membership_applications" // Use to instead of href
                  selected={
                    pathname ===
                    "/ppkm/admin/affiliate_individual_membership_applications"
                  }
                >
                  <ListItemIcon>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText primary="Affiliate Individual" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link} // Use Link here
                  href="/ppkm/admin/associate_membership_applications" // Use to instead of href
                  selected={
                    pathname === "/ppkm/admin/associate_membership_applications"
                  }
                >
                  <ListItemIcon>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText primary="Associate" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link} // Use Link here
                  href="/ppkm/admin/honorary_membership_applications" // Use to instead of href
                  selected={
                    pathname === "/ppkm/admin/honorary_membership_applications"
                  }
                >
                  <ListItemIcon>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText primary="Honorary" />
                </ListItemButton>
              </List>
            </Collapse>
          </ListItem>
        </List>

        <List>
          <ListItem key="secretariat" disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={[
                {
                  minHeight: 48,
                  px: 2.5,
                },
                open
                  ? {
                      justifyContent: "initial",
                    }
                  : {
                      justifyContent: "center",
                    },
              ]}
              onClick={handleClickSecretariat}
            >
              <ListItemIcon
                sx={[
                  {
                    minWidth: 0,
                    justifyContent: "center",
                  },
                  open
                    ? {
                        mr: 3,
                      }
                    : {
                        mr: "auto",
                      },
                ]}
              >
                <SupervisorAccountIcon />
              </ListItemIcon>
              <ListItemText
                primary="Secretariat"
                sx={[
                  open
                    ? {
                        opacity: 1,
                      }
                    : {
                        opacity: 0,
                      },
                ]}
              />
              {openCollapseSecretariat ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openCollapseSecretariat} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/secretariat_list"
                  selected={pathname === "/ppkm/admin/secretariat_list"}
                >
                  <ListItemIcon>
                    <GroupsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Lists" />
                </ListItemButton>
                {/* <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/register_secretariat"
                  selected={
                    pathname === "/ppkm/admin/register_secretariat"
                      ? true
                      : false
                  }
                >
                  <ListItemIcon>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText primary="Register" />
                </ListItemButton> */}
              </List>
            </Collapse>
          </ListItem>
        </List>

        <List>
          <ListItem key="signature" disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={[
                {
                  minHeight: 48,
                  px: 2.5,
                },
                open
                  ? {
                      justifyContent: "initial",
                    }
                  : {
                      justifyContent: "center",
                    },
              ]}
              onClick={handleClickSignature}
            >
              <ListItemIcon
                sx={[
                  {
                    minWidth: 0,
                    justifyContent: "center",
                  },
                  open
                    ? {
                        mr: 3,
                      }
                    : {
                        mr: "auto",
                      },
                ]}
              >
                <NoteAltIcon />
              </ListItemIcon>
              <ListItemText
                primary="Signature"
                sx={[
                  open
                    ? {
                        opacity: 1,
                      }
                    : {
                        opacity: 0,
                      },
                ]}
              />
              {openCollapseSignature ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={openCollapseSignature} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {/* Signature List */}
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/signatures"
                  selected={pathname === "/ppkm/admin/signatures"}
                >
                  <ListItemIcon>
                    <NoteAltIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Signatures"
                    sx={{
                      whiteSpace: "normal", // Allow text to wrap
                      overflow: "hidden", // Optional: hides overflowed text
                      textOverflow: "ellipsis", // Optional: adds ellipsis if text overflows
                    }}
                  />
                </ListItemButton>
                {/* Create Signature */}
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/create_signature_info"
                  selected={pathname === "/ppkm/admin/create_signature_info"}
                >
                  <ListItemIcon>
                    <AddCircleOutlineIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Create Signature"
                    sx={{
                      whiteSpace: "normal", // Allow text to wrap
                      overflow: "hidden", // Optional: hides overflowed text
                      textOverflow: "ellipsis", // Optional: adds ellipsis if text overflows
                    }}
                  />
                </ListItemButton>
              </List>
            </Collapse>
          </ListItem>
        </List>

        {/* <List>
          <ListItem key="invoice" disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={[
                {
                  minHeight: 48,
                  px: 2.5,
                },
                open
                  ? {
                      justifyContent: "initial",
                    }
                  : {
                      justifyContent: "center",
                    },
              ]}
              onClick={handleClickInvoice}
            >
              <ListItemIcon
                sx={[
                  {
                    minWidth: 0,
                    justifyContent: "center",
                  },
                  open
                    ? {
                        mr: 3,
                      }
                    : {
                        mr: "auto",
                      },
                ]}
              >
                <ReceiptIcon />
              </ListItemIcon>
              <ListItemText
                primary="Invoice"
                sx={[
                  open
                    ? {
                        opacity: 1,
                      }
                    : {
                        opacity: 0,
                      },
                ]}
              />
              {openCollapseInvoice ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openCollapseInvoice} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/membership_invoice"
                  selected={pathname === "/ppkm/admin/membership_invoice"}
                >
                  <ListItemIcon>
                    <ReceiptIcon />
                  </ListItemIcon>
                  <ListItemText primary="Memberships" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/event_invoice"
                  selected={
                    pathname === "/ppkm/admin/event_invoice" ? true : false
                  }
                >
                  <ListItemIcon>
                    <ReceiptIcon />
                  </ListItemIcon>
                  <ListItemText primary="Events" />
                </ListItemButton>
              </List>
            </Collapse>
          </ListItem>
        </List>

        <List>
          <ListItem
            key="invoice_notes"
            disablePadding
            sx={{ display: "block" }}
          >
            <ListItemButton
              sx={[
                {
                  minHeight: 48,
                  px: 2.5,
                },
                open
                  ? {
                      justifyContent: "initial",
                    }
                  : {
                      justifyContent: "center",
                    },
              ]}
              onClick={handleClickInvoiceNotes}
            >
              <ListItemIcon
                sx={[
                  {
                    minWidth: 0,
                    justifyContent: "center",
                  },
                  open
                    ? {
                        mr: 3,
                      }
                    : {
                        mr: "auto",
                      },
                ]}
              >
                <ReceiptIcon />
              </ListItemIcon>
              <ListItemText
                primary="Invoice Notes"
                sx={[
                  open
                    ? {
                        opacity: 1,
                      }
                    : {
                        opacity: 0,
                      },
                ]}
              />
              {openCollapseInvoiceNotes ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse
              in={openCollapseInvoiceNotes}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/invoice_notes"
                  selected={
                    pathname === "/ppkm/admin/invoice_notes" ? true : false
                  }
                >
                  <ListItemIcon>
                    <StickyNote2Icon />
                  </ListItemIcon>
                  <ListItemText primary="Notes " />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/member_fee_notes"
                  selected={
                    pathname === "/ppkm/admin/member_fee_notes" ? true : false
                  }
                >
                  <ListItemIcon>
                    <AttachMoneyIcon />
                  </ListItemIcon>
                  <ListItemText primary="Member Fees " />
                </ListItemButton>
              </List>
            </Collapse>
          </ListItem>
        </List> */}

        <List>
          <ListItem
            key="application_form"
            disablePadding
            sx={{ display: "block" }}
          >
            <ListItemButton
              sx={[
                {
                  minHeight: 48,
                  px: 2.5,
                },
                open
                  ? {
                      justifyContent: "initial",
                    }
                  : {
                      justifyContent: "center",
                    },
              ]}
              onClick={handleClickApplicationForm}
            >
              <ListItemIcon
                sx={[
                  {
                    minWidth: 0,
                    justifyContent: "center",
                  },
                  open
                    ? {
                        mr: 3,
                      }
                    : {
                        mr: "auto",
                      },
                ]}
              >
                <FeedIcon />
              </ListItemIcon>
              <ListItemText
                primary="Application Form"
                sx={[
                  open
                    ? {
                        opacity: 1,
                      }
                    : {
                        opacity: 0,
                      },
                ]}
              />
              {openCollapseApplicationForm ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse
              in={openCollapseApplicationForm}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/corporate_form"
                  selected={pathname === "/ppkm/admin/corporate_form"}
                >
                  <ListItemIcon>
                    <GroupsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Corporate" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/individual_form"
                  selected={
                    pathname === "/ppkm/admin/individual_form" ? true : false
                  }
                >
                  <ListItemIcon>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText primary="Individual" />
                </ListItemButton>
              </List>
            </Collapse>
          </ListItem>
        </List>

        <List>
          <ListItem key="audit_trail" disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={[
                {
                  minHeight: 48,
                  px: 2.5,
                },
                open
                  ? {
                      justifyContent: "initial",
                    }
                  : {
                      justifyContent: "center",
                    },
              ]}
              onClick={handleClickAuditTrail}
            >
              <ListItemIcon
                sx={[
                  {
                    minWidth: 0,
                    justifyContent: "center",
                  },
                  open
                    ? {
                        mr: 3,
                      }
                    : {
                        mr: "auto",
                      },
                ]}
              >
                <HistoryIcon />
              </ListItemIcon>
              <ListItemText
                primary="Audit Trails"
                sx={[
                  open
                    ? {
                        opacity: 1,
                      }
                    : {
                        opacity: 0,
                      },
                ]}
              />
              {openCollapseAuditTrail ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={openCollapseAuditTrail} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {/* CMS Audit List */}
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/cms_audits"
                  selected={pathname === "/ppkm/admin/cms_audits"}
                >
                  <ListItemIcon>
                    <NoteAltIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="CMS Audit Trail"
                    sx={{
                      whiteSpace: "normal", // Allow text to wrap
                      overflow: "hidden", // Optional: hides overflowed text
                      textOverflow: "ellipsis", // Optional: adds ellipsis if text overflows
                    }}
                  />
                </ListItemButton>
                {/* Mobile Audit List */}
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/mobile_audits"
                  selected={pathname === "/ppkm/admin/mobile_audits"}
                >
                  <ListItemIcon>
                    <NoteAltIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Mobile Audit Trail"
                    sx={{
                      whiteSpace: "normal", // Allow text to wrap
                      overflow: "hidden", // Optional: hides overflowed text
                      textOverflow: "ellipsis", // Optional: adds ellipsis if text overflows
                    }}
                  />
                </ListItemButton>
                {/* Web Audit List */}
                {/* <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/web_audits"
                  selected={pathname === "/ppkm/admin/web_audits"}
                >
                  <ListItemIcon>
                    <NoteAltIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Web Audit Trail"
                    sx={{
                      whiteSpace: "normal", // Allow text to wrap
                      overflow: "hidden", // Optional: hides overflowed text
                      textOverflow: "ellipsis", // Optional: adds ellipsis if text overflows
                    }}
                  />
                </ListItemButton> */}
              </List>
            </Collapse>
          </ListItem>
        </List>

        {/* added by delon 2025-05-29 */}
        <List>
          <ListItem key="user_manual" disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={[
                {
                  minHeight: 48,
                  px: 2.5,
                },
                open
                  ? {
                      justifyContent: "initial",
                    }
                  : {
                      justifyContent: "center",
                    },
              ]}
              onClick={handleClickUserManual}
            >
              <ListItemIcon
                sx={[
                  {
                    minWidth: 0,
                    justifyContent: "center",
                  },
                  open
                    ? {
                        mr: 3,
                      }
                    : {
                        mr: "auto",
                      },
                ]}
              >
                <HelpIcon />
              </ListItemIcon>
              <ListItemText
                primary="User Manual"
                sx={[
                  open
                    ? {
                        opacity: 1,
                      }
                    : {
                        opacity: 0,
                      },
                ]}
              />
              {openCollapseUserManual ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={openCollapseUserManual} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {/* CMS Audit List */}
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="https://www.ppkm.org.my/mobile_backend/assets/miscellaneous/PPKM_CMS_USER_MANUAL.pdf"
                >
                  <ListItemIcon>
                    <AdminPanelSettingsIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="CMS User Manual"
                    sx={{
                      whiteSpace: "normal", // Allow text to wrap
                      overflow: "hidden", // Optional: hides overflowed text
                      textOverflow: "ellipsis", // Optional: adds ellipsis if text overflows
                    }}
                  />
                </ListItemButton>
                {/* Mobile Audit List */}
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="https://www.ppkm.org.my/mobile_backend/assets/miscellaneous/PPKM_SUPERAPP_MEMBERSHIP.pdf"
                >
                  <ListItemIcon>
                    <SmartphoneIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Mobile App (Membership)"
                    sx={{
                      whiteSpace: "normal", // Allow text to wrap
                      overflow: "hidden", // Optional: hides overflowed text
                      textOverflow: "ellipsis", // Optional: adds ellipsis if text overflows
                    }}
                  />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="https://www.ppkm.org.my/mobile_backend/assets/miscellaneous/PPKM_SUPERAPP_SECRETARIAT.pdf"
                >
                  <ListItemIcon>
                    <AppShortcutIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Mobile App (Secretariate)"
                    sx={{
                      whiteSpace: "normal", // Allow text to wrap
                      overflow: "hidden", // Optional: hides overflowed text
                      textOverflow: "ellipsis", // Optional: adds ellipsis if text overflows
                    }}
                  />
                </ListItemButton>
                {/* Web Audit List */}
                {/* <ListItemButton
                  sx={{ pl: 4 }}
                  // component={Link}
                  href="/ppkm/admin/web_audits"
                  selected={pathname === "/ppkm/admin/web_audits"}
                >
                  <ListItemIcon>
                    <NoteAltIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Web Audit Trail"
                    sx={{
                      whiteSpace: "normal", // Allow text to wrap
                      overflow: "hidden", // Optional: hides overflowed text
                      textOverflow: "ellipsis", // Optional: adds ellipsis if text overflows
                    }}
                  />
                </ListItemButton> */}
              </List>
            </Collapse>
          </ListItem>
        </List>
      </Drawer>
      {children}
    </Box>
  );
}
